export default __webpack_public_path__ + "static/media/administrator.fabd9b92.svg";